module.exports = __webpack_public_path__ + "static/img/login-background.de99ea1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-background.jpg
// module id = 117
// module chunks = 20